export const DOMINO_ROUTE_FLAG = 'Domino_Route_Flag';
export const DOMINO_LOGIN_FLAG = 'Domino_Login_Flag';
